<template>
  <div class="page-container">
    <el-form
      :inline="true"
      class="demo-form-inline toolbar"
      style="padding-bottom: 0px"
    >
      <el-form-item>
        <kt-button
          type="warning"
          icon="el-icon-back"
          label="返回"
          @click="goBack()"
        />
      </el-form-item>
    </el-form>
    <div class="content" v-loading="loading" element-loading-text="拼命加载中">
      <giftsrecord-detail :dataInfo="dataInfo"></giftsrecord-detail>
    </div>
  </div>
</template>
<script>
import KtButton from "@/components/KtButton";
import giftsrecordDetail from "@/components/GiftsRecordDetail";
export default {
  components: { KtButton, giftsrecordDetail },
  data() {
    return {
      loading: true,
      id: "",
      avatar: "",
      //传给子组件的值
      dataInfo: {},
    };
  },
  methods: {
    goBack() {
      console.log("返回上层");
      bus.$emit('close_current_tags');
    },
    getGiftRecordDetail() {
      let params = {
        pageNum: 0,
        pageSize: 0,
      };
      this.id = this.$route.query.id;
      this.$postJson("omc/convert/queryListWithPage", this.params).then(
        (res) => {
          console.log(res.result);
          res.result.list.forEach((item) => {
            console.log(item.sex + "-----------");
            item.sex == 0 ? (item.sex = "女") : (item.sex = "男");
            item.convertType = item.convertType.replace(/\s*/g, "");
            item.convertType == "online"
              ? (item.convertType = "线上")
              : (item.convertType = "线下");
            item.stat == 0
              ? (item.stat = "已完成")
              : item.stat == 1
              ? (item.stat = "待发货")
              : (item.stat = "已发货");
            if (this.id == item.id) {
              this.dataInfo = item;
              return;
            }
          });
          console.log(this.dataInfo);
          let giftPicId = this.dataInfo.giftPic;
          this.getImgInfo(giftPicId);
          setTimeout(() => {
            this.loading = false;
          }, 500);
        }
      );
    },
    //图片的回显
    getImgInfo(infoData) {
      let id = infoData;
      console.log(id);
      if (id) {
        this.$postForm("opc/file/queryAttachmentById/" + id).then((res) => {
          console.log(res);
          var path = res.result.path;
          var name = res.result.name;
          this.avatar = "http://51cs8.com/" + path + name;
          this.dataInfo.giftPic = this.avatar;
        });
      }
    },
  },
  mounted() {
    this.getGiftRecordDetail();
  },
};
</script>
<style lang="scss" scoped>
.page-container {
  height: 500px;
  display: flex;
  flex-direction: column;
  background: #fff;
  .demo-form-inline {
    height: 60px;
  }
  .content {
    width: 99%;
    flex: 1;
    background: #fff;
  }
}
</style>
